/* eslint-disable arrow-body-style */
import { formatarMilhares, formatarNumeroDeQuantidade } from '@/utils';
import { formatDate } from '@/utils/tableColumns';

export function TRANSFORMAR_VALORES(payload) {
  const incentivosFormatados = payload.map((incentivo) => {
    return {
      ...incentivo,
      processo: incentivo.referenciaCliente || incentivo.referenciaInterna,
      dataCadastro: incentivo.dataCadastro ? formatDate(incentivo.dataCadastro) : 'N/I',
      icmsPago: incentivo.icmsPago ? formatarMilhares(incentivo.icmsPago) : 'N/I',
      pctBaseCliente: incentivo.pctBaseCliente ? `${incentivo.pctBaseCliente.toFixed(2)} %` : 'N/I',
      pctEmpresa: incentivo.pctEmpresa ? `${incentivo.pctEmpresa.toFixed(2)} %` : 'N/I',
      pctCliente: incentivo.pctCliente ? `${incentivo.pctCliente.toFixed(2)} %` : 'N/I',
      valorCliente: incentivo.valorCliente ? formatarMilhares(incentivo.valorCliente) : 'N/I',
      valor: incentivo.valor ? formatarMilhares(incentivo.valor) : 'N/I',
      quantidadeProduto: incentivo.quantidadeProduto ? formatarNumeroDeQuantidade(incentivo.quantidadeProduto) : 'N/I',
    };
  });

  return incentivosFormatados;
}

export default {
  SET_INCENTIVOS_FISCAIS(state, payload) {
    state.incentivosFiscais = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
};
